import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export interface SafeDrivingGuideBottomSheetEuProps {
  fromDate: string;
  toDate: string;
}

export default function ({fromDate, toDate}: SafeDrivingGuideBottomSheetEuProps) {
  const {t} = useInferableTranslation();

  return (
    <div className="bottom_sheet safe_driving">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('ctn_dss_LN_driving_safety_score')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('ctn_home_close')}
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <p
            className="bottom_sheet_text"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('msg_dss_LN_driving_safety_score_explain')}
          </p>

          {fromDate && toDate && (
            <div className="date_info_area">
              <p className="title">{t('ctn_dss_LN_calculation_date_range')}</p>
              <span className="date">
                {fromDate} ~ {toDate}
              </span>
            </div>
          )}

          <h3 className="title_small_b">{t('ctn_dss_LN_driving_safety_sub_scores')}</h3>
          <h4 className="bottom_sheet_title_sub">{t('ctn_dss_LN_estimated_annual_driving_distance')}</h4>
          <p className="bottom_sheet_text">{t('msg_dss_LN_estimated_annual_driving_distance_explain')}</p>
          <h4 className="bottom_sheet_title_sub">{t('ctn_dss_LN_hard_braking')}</h4>
          <p className="bottom_sheet_text">{t('msg_dss_LN_hard_braking_explain')}</p>
          <h4 className="bottom_sheet_title_sub">{t('ctn_dss_LN_average_speed')}</h4>
          <p className="bottom_sheet_text">{t('msg_dss_LN_average_speed_explain')}</p>
          <h4 className="bottom_sheet_title_sub">{t('ctn_dss_LN_maximum_speed')}</h4>
          <p className="bottom_sheet_text">{t('msg_dss_LN_maximum_speed_explain')}</p>
          <h4 className="bottom_sheet_title_sub">{t('ctn_dss_LN_driving_hours')}</h4>
          <p
            className="bottom_sheet_description"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('ctn_dss_LN_driving_hours_weekend_mornings')}
            <br />
            {t('msg_dss_LN_driving_hours_weekend_mornings_explain')}
          </p>
          <p
            className="bottom_sheet_description"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('ctn_dss_LN_driving_hours_evenings')}
            <br />
            {t('msg_dss_LN_driving_hours_evenings_explain')}
          </p>
          <p
            className="bottom_sheet_description"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('ctn_dss_LN_driving_hours_nighttime')}
            <br />
            {t('msg_dss_LN_driving_hours_nighttime_explain')}
          </p>
        </div>

        <div className="bottom_sheet_footer bottom_sheet_footer_vertical">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose()}
          >
            {t('ctn_dss_LN_confrim')}
          </button>
        </div>
      </div>
    </div>
  );
}
